import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
    selector: 'tran-primary-button',
    imports: [TranslatePipe],
    templateUrl: './primary-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrimaryButtonComponent extends BaseButtonComponent {
    public readonly href = input<string>();
    public readonly ariaLabel = input<string>();
}
